import api from 'api';
import { buildQueryParams } from 'helpers/util';

export const SALES_CONSULTANT_RESET_STATE = 'SALES_CONSULTANT_RESET_STATE';
export const SALES_CONSULTANT_ASYNC_START = 'SALES_CONSULTANT_ASYNC_START';
export const SALES_CONSULTANT_ASYNC_ERROR = 'SALES_CONSULTANT_ASYNC_ERROR';
export const SALES_CONSULTANT_ASYNC_SUCCESS = 'SALES_CONSULTANT_ASYNC_SUCCESS';

export const salesConsultantReset = () => ({
    type: SALES_CONSULTANT_RESET_STATE,
});

const salesConsultantError = error => ({
    type: SALES_CONSULTANT_ASYNC_ERROR,
    payload: { error },
});

const salesConsultantStart = () => ({
    type: SALES_CONSULTANT_ASYNC_START,
});

const salesConsultantUpdate = data => ({
    type: SALES_CONSULTANT_ASYNC_SUCCESS,
    payload: { data }
});

/**
 * Fetch sales consultants
 * @param {String} opcoId opco Id
 * @param {String} adId federation Id
 * @returns response
 */
export function fetchInternalSalesConsultants(opcoId, adId) {
    return (dispatch) => {

        const queryParams = buildQueryParams({ opcoId, adId });
        dispatch(salesConsultantStart());
        return api.request(`account/internal/salesConsultants`, 'get', null, null, null, queryParams)
            .then(data => {
                dispatch(salesConsultantUpdate(data));
                return data;
            })
            .catch((err) => {
                dispatch(salesConsultantError(err && err.message));
            });
    };
}
